import { imageUrl } from '@/utils/assets';

export const invoices = [
  {
    id: 'inv-2421',
    number: 'INV-2421',
    creatorId: 'crt-zawadi',
    creatorName: 'Zawadi Mwangi',
    avatar: imageUrl('creators/crt-zawadi.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 96000,
    tax: 0,
    amount: 96000,
    status: 'Pending review',
    issuedAt: '2026-09-06',
    dueAt: '2026-09-18',
    deliverableRef: 'Tutorial Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Vitamin-C range launch. Creator requested 30-day paid amplification rights included in rate.',
    flags: ['Deadline at risk'],
    lineItems: [
      { id: 'li-2421-1', description: 'Tutorial Reel · TikTok', detail: '2-part vitamin-C routine, 45s', amount: 64000 },
      { id: 'li-2421-2', description: 'Usage rights · 30 days', detail: 'Paid amplification on Instagram + TikTok', amount: 32000 },
    ],
    checks: [
      { id: 'chk-2421-1', label: 'Deliverables approved', status: 'warn', detail: 'Reel 1 approved · Reel 2 still in review' },
      { id: 'chk-2421-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 96,000 for the brief' },
      { id: 'chk-2421-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2421-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2421-1', actor: 'Zawadi Mwangi', action: 'Submitted invoice', at: '6 Sep 2026 · 09:12' },
      { id: 'tr-2421-2', actor: 'CPaaS automation', action: 'Validation completed · 1 warning', at: '6 Sep 2026 · 09:13' },
    ],
  },
  {
    id: 'inv-2420',
    number: 'INV-2420',
    creatorId: 'crt-grace',
    creatorName: 'Grace Wambui',
    avatar: imageUrl('creators/crt-grace.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 76000,
    tax: 0,
    amount: 76000,
    status: 'Pending review',
    issuedAt: '2026-09-05',
    dueAt: '2026-09-16',
    deliverableRef: 'Routine Story Set · Instagram',
    rail: 'Bank transfer · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'All five story frames delivered and approved ahead of schedule.',
    flags: [],
    lineItems: [
      { id: 'li-2420-1', description: 'Routine Story Set · Instagram', detail: '5-frame story set, morning routine', amount: 66000 },
      { id: 'li-2420-2', description: 'Organic repost rights', detail: '90-day brand social usage', amount: 10000 },
    ],
    checks: [
      { id: 'chk-2420-1', label: 'Deliverables approved', status: 'pass', detail: 'All 5 frames approved on 9 Sep' },
      { id: 'chk-2420-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 76,000 for the brief' },
      { id: 'chk-2420-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2420-4', label: 'Budget available', status: 'pass', detail: 'GlowRite campaign has KES 380,000 headroom' },
    ],
    trail: [
      { id: 'tr-2420-1', actor: 'Grace Wambui', action: 'Submitted invoice', at: '5 Sep 2026 · 16:40' },
      { id: 'tr-2420-2', actor: 'CPaaS automation', action: 'Validation passed', at: '5 Sep 2026 · 16:41' },
    ],
  },
  {
    id: 'inv-2418',
    number: 'INV-2418',
    creatorId: 'crt-sanaa',
    creatorName: 'Sanaa Njeri',
    avatar: imageUrl('creators/crt-sanaa.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 42000,
    tax: 0,
    amount: 42000,
    status: 'Pending review',
    issuedAt: '2026-09-04',
    dueAt: '2026-09-15',
    deliverableRef: 'Unboxing Reel · Instagram',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Food-meets-skincare crossover unboxing. Reel driving strong saves.',
    flags: [],
    lineItems: [
      { id: 'li-2418-1', description: 'Unboxing Reel · Instagram', detail: '60s unboxing + first-use reaction', amount: 42000 },
    ],
    checks: [
      { id: 'chk-2418-1', label: 'Deliverables approved', status: 'pass', detail: 'Reel approved on 8 Sep' },
      { id: 'chk-2418-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 42,000 for the brief' },
      { id: 'chk-2418-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2418-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2418-1', actor: 'Sanaa Njeri', action: 'Submitted invoice', at: '4 Sep 2026 · 11:20' },
      { id: 'tr-2418-2', actor: 'CPaaS automation', action: 'Validation passed', at: '4 Sep 2026 · 11:21' },
    ],
  },
  {
    id: 'inv-2416',
    number: 'INV-2416',
    creatorId: 'crt-furaha',
    creatorName: 'Furaha Salim',
    avatar: imageUrl('creators/crt-furaha.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 32000,
    tax: 0,
    amount: 32000,
    status: 'Approved',
    issuedAt: '2026-09-01',
    dueAt: '2026-09-12',
    deliverableRef: 'Testimonial Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved by Grace Kim (Finance). Queued for the next payout batch.',
    advance: { percent: 80, amount: 25600, fee: 720, advancedAt: '2026-09-08', reference: 'ADV-3301' },
    flags: [],
    lineItems: [
      { id: 'li-2416-1', description: 'Testimonial Reel · TikTok', detail: '45s authentic first-person review', amount: 32000 },
    ],
    checks: [
      { id: 'chk-2416-1', label: 'Deliverables approved', status: 'pass', detail: 'Reel approved on 3 Sep' },
      { id: 'chk-2416-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 32,000 for the brief' },
      { id: 'chk-2416-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2416-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2416-1', actor: 'Furaha Salim', action: 'Submitted invoice', at: '1 Sep 2026 · 08:55' },
      { id: 'tr-2416-2', actor: 'Grace Kim', action: 'Approved invoice', at: '3 Sep 2026 · 10:05', note: 'Deliverable strong, rate correct.' },
    ],
  },
  {
    id: 'inv-2411',
    number: 'INV-2411',
    creatorId: 'crt-brian',
    creatorName: 'Brian Otieno',
    avatar: imageUrl('creators/crt-brian.webp'),
    campaignId: 'cmp-tusker-weekend',
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 74500,
    tax: 0,
    amount: 74500,
    status: 'Pending review',
    issuedAt: '2026-09-07',
    dueAt: '2026-09-19',
    deliverableRef: 'Weekend Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Invoice raised for the final reel. One deliverable still outstanding on the campaign.',
    flags: ['Deliverable missing'],
    lineItems: [
      { id: 'li-2411-1', description: 'Weekend Reel · TikTok', detail: '45s nightlife reel, final cut', amount: 74500 },
    ],
    checks: [
      { id: 'chk-2411-1', label: 'Deliverables approved', status: 'fail', detail: 'Final reel not yet submitted on the campaign' },
      { id: 'chk-2411-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 74,500 for the brief' },
      { id: 'chk-2411-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2411-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2411-1', actor: 'Brian Otieno', action: 'Submitted invoice', at: '7 Sep 2026 · 14:02' },
      { id: 'tr-2411-2', actor: 'CPaaS automation', action: 'Validation failed · deliverable missing', at: '7 Sep 2026 · 14:03' },
    ],
  },
  {
    id: 'inv-2409',
    number: 'INV-2409',
    creatorId: 'crt-tunde',
    creatorName: 'Tunde Bakari',
    avatar: imageUrl('creators/crt-tunde.webp'),
    campaignId: 'cmp-tusker-weekend',
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Tanzania',
    currency: 'TZS',
    subtotal: 6800000,
    tax: 0,
    amount: 6800000,
    status: 'Approved',
    issuedAt: '2026-08-29',
    dueAt: '2026-09-14',
    deliverableRef: 'Hype Reel · TikTok',
    rail: 'Tigo Pesa · TZS',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved. Cross-border settlement scheduled on the Tanzania rail.',
    advance: { percent: 60, amount: 4080000, fee: 122400, advancedAt: '2026-09-04', reference: 'ADV-3303' },
    flags: [],
    lineItems: [
      { id: 'li-2409-1', description: 'Hype Reel · TikTok', detail: '30s festival hype cut', amount: 5000000 },
      { id: 'li-2409-2', description: 'Story amplification · Instagram', detail: '6-story weekend takeover', amount: 1800000 },
    ],
    checks: [
      { id: 'chk-2409-1', label: 'Deliverables approved', status: 'pass', detail: 'Reel + stories approved on 31 Aug' },
      { id: 'chk-2409-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed TZS 6,800,000 for the brief' },
      { id: 'chk-2409-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2409-4', label: 'Wallet ready', status: 'pass', detail: 'Tigo Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2409-1', actor: 'Tunde Bakari', action: 'Submitted invoice', at: '29 Aug 2026 · 12:30' },
      { id: 'tr-2409-2', actor: 'Peter Kironji', action: 'Approved invoice', at: '31 Aug 2026 · 09:18' },
    ],
  },
  {
    id: 'inv-2406',
    number: 'INV-2406',
    creatorId: 'crt-emmanuel',
    creatorName: 'Emmanuel Okello',
    avatar: imageUrl('creators/crt-emmanuel.webp'),
    campaignId: 'cmp-tusker-weekend',
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Uganda',
    currency: 'UGX',
    subtotal: 4200000,
    tax: 0,
    amount: 4200000,
    status: 'Paid',
    issuedAt: '2026-08-20',
    dueAt: '2026-09-02',
    deliverableRef: 'Match-day Story · X',
    rail: 'MTN MoMo · UGX',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Settled in full on 2 Sep 2026. Reference PAY-77120.',
    flags: [],
    lineItems: [
      { id: 'li-2406-1', description: 'Match-day Story · X', detail: 'Live match-day thread, 3 posts', amount: 4200000 },
    ],
    checks: [
      { id: 'chk-2406-1', label: 'Deliverables approved', status: 'pass', detail: 'Thread approved on 22 Aug' },
      { id: 'chk-2406-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed UGX 4,200,000 for the brief' },
      { id: 'chk-2406-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2406-4', label: 'Wallet ready', status: 'pass', detail: 'MTN MoMo wallet active' },
    ],
    trail: [
      { id: 'tr-2406-1', actor: 'Emmanuel Okello', action: 'Submitted invoice', at: '20 Aug 2026 · 10:14' },
      { id: 'tr-2406-2', actor: 'Grace Kim', action: 'Approved invoice', at: '21 Aug 2026 · 15:02' },
      { id: 'tr-2406-3', actor: 'CPaaS automation', action: 'Paid · MTN MoMo · ref PAY-77120', at: '2 Sep 2026 · 09:00' },
    ],
  },
  {
    id: 'inv-2401',
    number: 'INV-2401',
    creatorId: 'crt-neema',
    creatorName: 'Neema Achieng',
    avatar: imageUrl('creators/crt-neema.webp'),
    campaignId: 'cmp-safipay-launch',
    campaign: 'SafiPay Fintech Launch',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 130000,
    tax: 0,
    amount: 130000,
    status: 'On hold',
    issuedAt: '2026-09-08',
    dueAt: '2026-09-22',
    deliverableRef: 'Explainer Video · YouTube',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC incomplete',
    notes: 'Held automatically — KYC verification is incomplete, contracting cannot be finalised.',
    flags: ['KYC incomplete'],
    lineItems: [
      { id: 'li-2401-1', description: 'Explainer Video · YouTube', detail: '3-min wallet explainer, long-form', amount: 95000 },
      { id: 'li-2401-2', description: 'Short Hook Reel · TikTok', detail: '20s vertical hook cut', amount: 35000 },
    ],
    checks: [
      { id: 'chk-2401-1', label: 'Deliverables approved', status: 'pass', detail: 'Both pieces approved on 9 Sep' },
      { id: 'chk-2401-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 130,000 for the brief' },
      { id: 'chk-2401-3', label: 'KYC & compliance', status: 'fail', detail: 'KYC incomplete — ID document pending' },
      { id: 'chk-2401-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2401-1', actor: 'Neema Achieng', action: 'Submitted invoice', at: '8 Sep 2026 · 13:44' },
      { id: 'tr-2401-2', actor: 'CPaaS automation', action: 'Placed on hold · KYC incomplete', at: '8 Sep 2026 · 13:45' },
    ],
  },
  {
    id: 'inv-2398',
    number: 'INV-2398',
    creatorId: 'crt-david',
    creatorName: 'David Mwansa',
    avatar: imageUrl('creators/crt-david.webp'),
    campaignId: 'cmp-safipay-launch',
    campaign: 'SafiPay Fintech Launch',
    market: 'Uganda',
    currency: 'UGX',
    subtotal: 2100000,
    tax: 0,
    amount: 2100000,
    status: 'Pending review',
    issuedAt: '2026-09-10',
    dueAt: '2026-09-24',
    deliverableRef: 'Wallet Walkthrough · Instagram',
    rail: 'Airtel Money · UGX',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Walkthrough is in final review; invoice raised in parallel for a fast turnaround.',
    flags: [],
    lineItems: [
      { id: 'li-2398-1', description: 'Wallet Walkthrough · Instagram', detail: '90s screen-capture walkthrough', amount: 2100000 },
    ],
    checks: [
      { id: 'chk-2398-1', label: 'Deliverables approved', status: 'warn', detail: 'Walkthrough submitted, review in progress' },
      { id: 'chk-2398-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed UGX 2,100,000 for the brief' },
      { id: 'chk-2398-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2398-4', label: 'Wallet ready', status: 'pass', detail: 'Airtel Money wallet active' },
    ],
    trail: [
      { id: 'tr-2398-1', actor: 'David Mwansa', action: 'Submitted invoice', at: '10 Sep 2026 · 09:31' },
      { id: 'tr-2398-2', actor: 'CPaaS automation', action: 'Validation completed · 1 warning', at: '10 Sep 2026 · 09:32' },
    ],
  },
  {
    id: 'inv-2394',
    number: 'INV-2394',
    creatorId: 'crt-halima',
    creatorName: 'Halima Yusuf',
    avatar: imageUrl('creators/crt-halima.webp'),
    campaignId: 'cmp-ubuntu-cosmetics',
    campaign: 'Ubuntu Cosmetics Heritage',
    market: 'Tanzania',
    currency: 'TZS',
    subtotal: 4200000,
    tax: 0,
    amount: 4200000,
    status: 'Approved',
    issuedAt: '2026-08-26',
    dueAt: '2026-09-13',
    deliverableRef: 'Heritage Film · YouTube',
    rail: 'M-Pesa · TZS',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved and queued. Long-form heritage film met all brief requirements.',
    flags: [],
    lineItems: [
      { id: 'li-2394-1', description: 'Heritage Film · YouTube', detail: '5-min brand storytelling film', amount: 4200000 },
    ],
    checks: [
      { id: 'chk-2394-1', label: 'Deliverables approved', status: 'pass', detail: 'Film approved on 28 Aug' },
      { id: 'chk-2394-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed TZS 4,200,000 for the brief' },
      { id: 'chk-2394-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2394-4', label: 'Budget available', status: 'pass', detail: 'Ubuntu campaign has TZS 8.2M remaining' },
    ],
    trail: [
      { id: 'tr-2394-1', actor: 'Halima Yusuf', action: 'Submitted invoice', at: '26 Aug 2026 · 17:20' },
      { id: 'tr-2394-2', actor: 'Grace Kim', action: 'Approved invoice', at: '28 Aug 2026 · 11:02' },
    ],
  },
  {
    id: 'inv-2390',
    number: 'INV-2390',
    creatorId: 'crt-jabari',
    creatorName: 'Jabari Kimani',
    avatar: imageUrl('creators/crt-jabari.webp'),
    campaignId: 'cmp-jua-health',
    campaign: 'Jua Health Awareness',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 88000,
    tax: 0,
    amount: 88000,
    status: 'Pending review',
    issuedAt: '2026-09-03',
    dueAt: '2026-09-17',
    deliverableRef: 'Wellness Explainer · YouTube',
    rail: 'Bank transfer · KES',
    walletStatus: 'Wallet inactive',
    kycStatus: 'KYC complete',
    notes: 'Wallet flagged inactive — a previous payout failed. Resolve before approving.',
    flags: ['Wallet inactive'],
    lineItems: [
      { id: 'li-2390-1', description: 'Wellness Explainer · YouTube', detail: '4-min maternal wellness explainer', amount: 72000 },
      { id: 'li-2390-2', description: 'Clips package · Instagram', detail: '3 vertical clips from the explainer', amount: 16000 },
    ],
    checks: [
      { id: 'chk-2390-1', label: 'Deliverables approved', status: 'pass', detail: 'Explainer + clips approved on 5 Sep' },
      { id: 'chk-2390-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 88,000 for the brief' },
      { id: 'chk-2390-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2390-4', label: 'Wallet ready', status: 'fail', detail: 'Wallet inactive — last payout failed' },
    ],
    trail: [
      { id: 'tr-2390-1', actor: 'Jabari Kimani', action: 'Submitted invoice', at: '3 Sep 2026 · 08:40' },
      { id: 'tr-2390-2', actor: 'CPaaS automation', action: 'Validation failed · wallet inactive', at: '3 Sep 2026 · 08:41' },
    ],
  },
  {
    id: 'inv-2385',
    number: 'INV-2385',
    creatorId: 'crt-sanaa',
    creatorName: 'Sanaa Njeri',
    avatar: imageUrl('creators/crt-sanaa.webp'),
    campaignId: 'cmp-farmfresh',
    campaign: 'FarmFresh Groceries Weekly',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 42000,
    tax: 0,
    amount: 42000,
    status: 'Paid',
    issuedAt: '2026-08-12',
    dueAt: '2026-08-26',
    deliverableRef: 'Weekly Recipe Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Settled in full on 26 Aug 2026. Reference PAY-77044.',
    flags: [],
    lineItems: [
      { id: 'li-2385-1', description: 'Weekly Recipe Reel · TikTok', detail: '3 weekly recipe reels (August)', amount: 42000 },
    ],
    checks: [
      { id: 'chk-2385-1', label: 'Deliverables approved', status: 'pass', detail: 'All 3 reels approved on 18 Aug' },
      { id: 'chk-2385-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 42,000 for the month' },
      { id: 'chk-2385-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2385-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2385-1', actor: 'Sanaa Njeri', action: 'Submitted invoice', at: '12 Aug 2026 · 10:00' },
      { id: 'tr-2385-2', actor: 'Grace Kim', action: 'Approved invoice', at: '12 Aug 2026 · 16:30' },
      { id: 'tr-2385-3', actor: 'CPaaS automation', action: 'Paid · M-Pesa · ref PAY-77044', at: '26 Aug 2026 · 09:00' },
    ],
  },
  {
    id: 'inv-2379',
    number: 'INV-2379',
    creatorId: 'crt-brian',
    creatorName: 'Brian Otieno',
    avatar: imageUrl('creators/crt-brian.webp'),
    campaignId: 'cmp-farmfresh',
    campaign: 'FarmFresh Groceries Weekly',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 30000,
    tax: 0,
    amount: 30000,
    status: 'Rejected',
    issuedAt: '2026-08-05',
    dueAt: '2026-08-19',
    deliverableRef: 'Grocery Haul Reel · Instagram',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Rejected — invoiced rate is above the agreed campaign rate. Creator asked to resubmit.',
    flags: ['Rate mismatch'],
    lineItems: [
      { id: 'li-2379-1', description: 'Grocery Haul Reel · Instagram', detail: '45s haul, first edit', amount: 30000 },
    ],
    checks: [
      { id: 'chk-2379-1', label: 'Deliverables approved', status: 'fail', detail: 'Reel rejected — brief non-compliance' },
      { id: 'chk-2379-2', label: 'Contracted rate match', status: 'fail', detail: 'Invoiced KES 30,000 · agreed rate KES 22,000' },
      { id: 'chk-2379-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2379-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2379-1', actor: 'Brian Otieno', action: 'Submitted invoice', at: '5 Aug 2026 · 09:10' },
      { id: 'tr-2379-2', actor: 'CPaaS automation', action: 'Validation failed · rate mismatch', at: '5 Aug 2026 · 09:11' },
      { id: 'tr-2379-3', actor: 'Grace Kim', action: 'Rejected invoice', at: '6 Aug 2026 · 14:25', note: 'Rate above agreed SLA. Please resubmit at KES 22,000.' },
    ],
  },
  {
    id: 'inv-2432',
    number: 'INV-2432',
    creatorId: 'crt-grace',
    creatorName: 'Grace Wambui',
    avatar: imageUrl('creators/crt-grace.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 76000,
    tax: 0,
    amount: 76000,
    status: 'Approved',
    issuedAt: '2026-09-07',
    dueAt: '2026-09-20',
    deliverableRef: 'Morning Routine Series · Instagram',
    rail: 'Bank transfer · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved by Grace Kim. Staged for the next bulk payout batch.',
    advance: { percent: 70, amount: 53200, fee: 1520, advancedAt: '2026-09-10', reference: 'ADV-3302' },
    flags: [],
    lineItems: [
      { id: 'li-2432-1', description: 'Morning Routine Series · Instagram', detail: '4-part routine series', amount: 66000 },
      { id: 'li-2432-2', description: 'Organic repost rights', detail: '90-day brand social usage', amount: 10000 },
    ],
    checks: [
      { id: 'chk-2432-1', label: 'Deliverables approved', status: 'pass', detail: 'All 4 posts approved on 8 Sep' },
      { id: 'chk-2432-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 76,000 for the brief' },
      { id: 'chk-2432-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2432-4', label: 'Wallet ready', status: 'pass', detail: 'Bank transfer wallet active' },
    ],
    trail: [
      { id: 'tr-2432-1', actor: 'Grace Wambui', action: 'Submitted invoice', at: '7 Sep 2026 · 08:30' },
      { id: 'tr-2432-2', actor: 'Grace Kim', action: 'Approved invoice', at: '8 Sep 2026 · 09:40' },
    ],
  },
  {
    id: 'inv-2433',
    number: 'INV-2433',
    creatorId: 'crt-sanaa',
    creatorName: 'Sanaa Njeri',
    avatar: imageUrl('creators/crt-sanaa.webp'),
    campaignId: 'cmp-farmfresh',
    campaign: 'FarmFresh Groceries Weekly',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 42000,
    tax: 0,
    amount: 42000,
    status: 'Approved',
    issuedAt: '2026-09-07',
    dueAt: '2026-09-22',
    deliverableRef: 'Weekly Recipe Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'August retainer approved. Ready to pay on the M-Pesa rail.',
    flags: [],
    lineItems: [
      { id: 'li-2433-1', description: 'Weekly Recipe Reel · TikTok', detail: '3 weekly recipe reels (September)', amount: 42000 },
    ],
    checks: [
      { id: 'chk-2433-1', label: 'Deliverables approved', status: 'pass', detail: 'All 3 reels approved on 7 Sep' },
      { id: 'chk-2433-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 42,000 for the month' },
      { id: 'chk-2433-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2433-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2433-1', actor: 'Sanaa Njeri', action: 'Submitted invoice', at: '7 Sep 2026 · 10:05' },
      { id: 'tr-2433-2', actor: 'Peter Kironji', action: 'Approved invoice', at: '7 Sep 2026 · 15:12' },
    ],
  },
  {
    id: 'inv-2434',
    number: 'INV-2434',
    creatorId: 'crt-zawadi',
    creatorName: 'Zawadi Mwangi',
    avatar: imageUrl('creators/crt-zawadi.webp'),
    campaignId: 'cmp-glowrite-q4',
    campaign: 'GlowRite Skincare Q4 Push',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 64000,
    tax: 0,
    amount: 64000,
    status: 'Approved',
    issuedAt: '2026-09-08',
    dueAt: '2026-09-21',
    deliverableRef: 'Tutorial Reel · TikTok',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved, but one supporting reel is still under review — confirm before releasing funds.',
    advance: { percent: 50, amount: 32000, fee: 960, advancedAt: '2026-09-11', reference: 'ADV-3304' },
    flags: ['Deliverable under review'],
    lineItems: [
      { id: 'li-2434-1', description: 'Tutorial Reel · TikTok', detail: '45s routine tutorial, final cut', amount: 64000 },
    ],
    checks: [
      { id: 'chk-2434-1', label: 'Deliverables approved', status: 'warn', detail: 'Supporting reel still in content review' },
      { id: 'chk-2434-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 64,000 for the brief' },
      { id: 'chk-2434-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2434-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2434-1', actor: 'Zawadi Mwangi', action: 'Submitted invoice', at: '8 Sep 2026 · 12:20' },
      { id: 'tr-2434-2', actor: 'Grace Kim', action: 'Approved invoice', at: '9 Sep 2026 · 09:15' },
    ],
  },
  {
    id: 'inv-2436',
    number: 'INV-2436',
    creatorId: 'crt-emmanuel',
    creatorName: 'Emmanuel Okello',
    avatar: imageUrl('creators/crt-emmanuel.webp'),
    campaignId: 'cmp-tusker-weekend',
    campaign: 'Tusker Lite Weekend Vibes',
    market: 'Uganda',
    currency: 'UGX',
    subtotal: 4200000,
    tax: 0,
    amount: 4200000,
    status: 'Approved',
    issuedAt: '2026-09-06',
    dueAt: '2026-09-18',
    deliverableRef: 'Match-day Reel · TikTok',
    rail: 'MTN MoMo · UGX',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved. Ugandan rail ready for the next batch.',
    flags: [],
    lineItems: [
      { id: 'li-2436-1', description: 'Match-day Reel · TikTok', detail: '30s match-day hype reel', amount: 4200000 },
    ],
    checks: [
      { id: 'chk-2436-1', label: 'Deliverables approved', status: 'pass', detail: 'Reel approved on 7 Sep' },
      { id: 'chk-2436-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed UGX 4,200,000 for the brief' },
      { id: 'chk-2436-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2436-4', label: 'Wallet ready', status: 'pass', detail: 'MTN MoMo wallet active' },
    ],
    trail: [
      { id: 'tr-2436-1', actor: 'Emmanuel Okello', action: 'Submitted invoice', at: '6 Sep 2026 · 11:00' },
      { id: 'tr-2436-2', actor: 'Grace Kim', action: 'Approved invoice', at: '7 Sep 2026 · 10:22' },
    ],
  },
  {
    id: 'inv-2437',
    number: 'INV-2437',
    creatorId: 'crt-david',
    creatorName: 'David Mwansa',
    avatar: imageUrl('creators/crt-david.webp'),
    campaignId: 'cmp-safipay-launch',
    campaign: 'SafiPay Fintech Launch',
    market: 'Uganda',
    currency: 'UGX',
    subtotal: 2100000,
    tax: 0,
    amount: 2100000,
    status: 'Approved',
    issuedAt: '2026-09-09',
    dueAt: '2026-09-24',
    deliverableRef: 'Wallet Walkthrough · Instagram',
    rail: 'Airtel Money · UGX',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC complete',
    notes: 'Approved with a budget caveat — confirm the launch budget line before payout.',
    flags: ['Budget to confirm'],
    lineItems: [
      { id: 'li-2437-1', description: 'Wallet Walkthrough · Instagram', detail: '90s screen-capture walkthrough', amount: 2100000 },
    ],
    checks: [
      { id: 'chk-2437-1', label: 'Deliverables approved', status: 'pass', detail: 'Walkthrough approved on 10 Sep' },
      { id: 'chk-2437-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed UGX 2,100,000 for the brief' },
      { id: 'chk-2437-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2437-4', label: 'Budget available', status: 'warn', detail: 'SafiPay launch budget line needs sign-off' },
    ],
    trail: [
      { id: 'tr-2437-1', actor: 'David Mwansa', action: 'Submitted invoice', at: '9 Sep 2026 · 09:12' },
      { id: 'tr-2437-2', actor: 'Grace Kim', action: 'Approved invoice', at: '10 Sep 2026 · 14:05' },
    ],
  },
  {
    id: 'inv-2439',
    number: 'INV-2439',
    creatorId: 'crt-jabari',
    creatorName: 'Jabari Kimani',
    avatar: imageUrl('creators/crt-jabari.webp'),
    campaignId: 'cmp-jua-health',
    campaign: 'Jua Health Awareness',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 88000,
    tax: 0,
    amount: 88000,
    status: 'Approved',
    issuedAt: '2026-09-05',
    dueAt: '2026-09-17',
    deliverableRef: 'Wellness Explainer · YouTube',
    rail: 'Bank transfer · KES',
    walletStatus: 'Wallet inactive',
    kycStatus: 'KYC complete',
    notes: 'Approved but payout-blocked — the wallet is inactive after a failed settlement.',
    flags: ['Wallet inactive'],
    lineItems: [
      { id: 'li-2439-1', description: 'Wellness Explainer · YouTube', detail: '4-min maternal wellness explainer', amount: 72000 },
      { id: 'li-2439-2', description: 'Clips package · Instagram', detail: '3 vertical clips from the explainer', amount: 16000 },
    ],
    checks: [
      { id: 'chk-2439-1', label: 'Deliverables approved', status: 'pass', detail: 'Explainer + clips approved on 6 Sep' },
      { id: 'chk-2439-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 88,000 for the brief' },
      { id: 'chk-2439-3', label: 'KYC & compliance', status: 'pass', detail: 'Identity verified, brand-safety clear' },
      { id: 'chk-2439-4', label: 'Wallet ready', status: 'fail', detail: 'Wallet inactive — last payout failed' },
    ],
    trail: [
      { id: 'tr-2439-1', actor: 'Jabari Kimani', action: 'Submitted invoice', at: '5 Sep 2026 · 08:40' },
      { id: 'tr-2439-2', actor: 'Grace Kim', action: 'Approved invoice', at: '6 Sep 2026 · 16:10' },
    ],
  },
  {
    id: 'inv-2440',
    number: 'INV-2440',
    creatorId: 'crt-neema',
    creatorName: 'Neema Achieng',
    avatar: imageUrl('creators/crt-neema.webp'),
    campaignId: 'cmp-safipay-launch',
    campaign: 'SafiPay Fintech Launch',
    market: 'Kenya',
    currency: 'KES',
    subtotal: 130000,
    tax: 0,
    amount: 130000,
    status: 'Approved',
    issuedAt: '2026-09-10',
    dueAt: '2026-09-22',
    deliverableRef: 'Explainer Video · YouTube',
    rail: 'M-Pesa · KES',
    walletStatus: 'Wallet active',
    kycStatus: 'KYC incomplete',
    notes: 'Approved but payout-blocked — KYC verification is still incomplete.',
    flags: ['KYC incomplete'],
    lineItems: [
      { id: 'li-2440-1', description: 'Explainer Video · YouTube', detail: '3-min wallet explainer, long-form', amount: 95000 },
      { id: 'li-2440-2', description: 'Short Hook Reel · TikTok', detail: '20s vertical hook cut', amount: 35000 },
    ],
    checks: [
      { id: 'chk-2440-1', label: 'Deliverables approved', status: 'pass', detail: 'Both pieces approved on 11 Sep' },
      { id: 'chk-2440-2', label: 'Contracted rate match', status: 'pass', detail: 'Matches agreed KES 130,000 for the brief' },
      { id: 'chk-2440-3', label: 'KYC & compliance', status: 'fail', detail: 'KYC incomplete — ID document pending' },
      { id: 'chk-2440-4', label: 'Wallet ready', status: 'pass', detail: 'M-Pesa wallet active' },
    ],
    trail: [
      { id: 'tr-2440-1', actor: 'Neema Achieng', action: 'Submitted invoice', at: '10 Sep 2026 · 13:44' },
      { id: 'tr-2440-2', actor: 'Grace Kim', action: 'Approved invoice', at: '11 Sep 2026 · 10:30' },
      { id: 'tr-2440-3', actor: 'CPaaS automation', action: 'Payout hold · KYC incomplete', at: '11 Sep 2026 · 10:31' },
    ],
  },
];

export const invoiceStatusTabs = [
  { id: 'all', label: 'All' },
  { id: 'Pending review', label: 'Pending review' },
  { id: 'On hold', label: 'On hold' },
  { id: 'Approved', label: 'Approved' },
  { id: 'Paid', label: 'Paid' },
  { id: 'Rejected', label: 'Rejected' },
];
